import { SET_SHARD, SET_WINDOW } from '../../actions/types';

export default (state = { timeWindow: 2592000 }, action) => {
  switch(action.type) {
    case SET_SHARD:
      return { ...state, shard: action.shard };
    case SET_WINDOW:
      return { ...state, timeWindow: action.timeWindow };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/config.js